import { ZervantSettings } from '../types/zervantSettings'
import { ZervantSettingsFields } from '../types/zervantSettingsFields'
import { ModelDocumentType } from '../types/zervantSettingsModelDocumentType'

export const getSettingsFieldsByDocumentType = (
  settings: ZervantSettings | undefined,
  documentType: ModelDocumentType,
): ZervantSettingsFields => {
  const documentModel = settings?.models.find((model) => model?.type === documentType)
  const fields = documentModel?.fields ?? []

  return Object.fromEntries(fields.map((field) => [field.name, field]))
}
